import * as angular from 'angular';
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.lean-planning')
  .factory('RoutesPageableAPI', RoutesPageableAPI);

function RoutesPageableAPI(): BringozApi {
  return {
    base: `/leanPlanning/routes/pageable`,
    actions: {
      getRoutes: {
        address: '',
        cmd: 'GET',
        updateable: false
      }
    }
  }
}
